import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { useLocale } from "@/i18n/context";
import { localizedPath } from "@/i18n/routes";

const NotFound = () => {
  const { t, locale } = useLocale();
  const homePath = localizedPath("home", locale);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-md animate-fade-in-up">
          <div className="mb-8">
            <p className="section-eyebrow mb-4">{t.notFound.eyebrow}</p>
            <h1 className="text-7xl sm:text-8xl font-extrabold tracking-tight text-primary mb-4">404</h1>
            <div className="w-20 h-1 bg-gradient-to-r from-primary to-accent mx-auto rounded-full" />
          </div>
          
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            {t.notFound.title}
          </h2>
          
          <p className="text-muted-foreground mb-8">
            {t.notFound.desc}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="default" size="lg">
              <Link to={homePath}>
                <Home className="mr-2 h-4 w-4" />
                {t.notFound.backHome}
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" onClick={() => window.history.back()}>
              <span className="cursor-pointer" onClick={() => window.history.back()}>
                <ArrowLeft className="mr-2 h-4 w-4" />
                {t.notFound.goBack}
              </span>
            </Button>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
